import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';
import { Messages } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';

export interface spotData {
  name: string;
  mobile: string;
  vehicle_no: string;
  vehicle_type: string;
  ws_opt_in: boolean;
  id: string;
  gps_id?: string;
  gps_provider?: string;
}

@Component({
  selector: 'app-spot-on-driver',
  templateUrl: './spot-on-driver.component.html',
  styleUrls: ['./spot-on-driver.component.scss']
})

export class SpotOnDriverComponent implements OnInit {

  spotDriverData: spotData = {
    name: '',
    mobile: '',
    vehicle_no: '',
    vehicle_type: '',
    ws_opt_in: false,
    id: ''
  };
  spinner = false;
  checked = false;
  selectedVehicleType: any = {};
  showLoader = false;
  vehicleType: any = {};
  vehicles: any = [];
  messages = new Messages();
  vehicle_pattern;
  defaultVehicle: any;
  editDriver = false;

  assets;
  assetsArray;
  selectedGPSProvider;
  selectedAsset;
  showGPSProvider = false;
  gps_providers = [];
  ksaGpsProviders = [];
  inGpsProviders = [];
  gpsProviders: any = [];

  constructor(private dialog: MatDialogRef<SpotOnDriverComponent>, private valid: ValidationService, private snackbar: SnackbarService,
              private http: HttpService, private translate: TranslateService, @Inject(MAT_DIALOG_DATA) private parentData: any) { }

  ngOnInit() {
    console.log('parent',this.parentData);
    this.getCarrierPrefs();
    this.getGPSProviders();
    if (this.parentData) {
      if (!this.parentData.editDriver && this.parentData.vehicle) {
        this.defaultVehicle = this.parentData.vehicle;
        this.vehicleType = this.defaultVehicle;
      }
      this.editDriver = this.parentData ? this.parentData.editDriver : false;
      if (this.editDriver) {
        this.spotDriverData.name = this.parentData.driverData.name;
        this.spotDriverData.mobile = this.parentData.driverData.mobile;
        this.spotDriverData.vehicle_no = this.parentData.driverData.vehicleNumber;
        this.spotDriverData.ws_opt_in = this.parentData.driverData.whatsApp;
        const vehicle: any = {
          name: this.parentData.driverData.vehicleType,
          _id: this.parentData.driverData.vehicleId
        };
        this.defaultVehicle = vehicle;
      }
    }
    this.vehicle_pattern = environment.vehicle_pattern;
  }

  getGPSProviders(){
    this.http.get('constants/carrier', '', 3).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.gps.length) {
            this.gps_providers = data.data.spot_gps;
            if(this.parentData && this.parentData.driverData && this.parentData.driverData.gps_provider){
              this.selectedGPSProvider = this.gps_providers.filter((provider)=>{
                return provider.value == this.parentData.driverData.gps_provider
              })[0];
              this.selectGPSProvider(this.selectedGPSProvider);
            }else{
              if(this.gps_providers.length == 1){
                this.selectGPSProvider(this.gps_providers[0]);
              }
            }
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  getCarrierPrefs() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (this.parentData && this.defaultVehicle._id) {
            this.vehicleType.id = this.defaultVehicle._id;
            this.vehicleType.name = this.defaultVehicle.name;
          } else {
            this.vehicleType = {};
          }
          if (data.data.vehicle_types.length) {
            this.vehicles = data.data.vehicle_types;
            if (this.editDriver) {
              const vehicle = this.vehicles.filter((vehicle) => {
                return vehicle._id == this.parentData.driverData.vehicleId;
              })[0];
              this.selectedVehicleType.name = vehicle.name;
              this.selectedVehicleType.id = vehicle._id;
            }
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  validate(data) {
    if ( !this.valid.isEmpty(this.spotDriverData.name) && !this.valid.isEmpty(this.spotDriverData.mobile) && !this.valid.isEmpty(this.spotDriverData.vehicle_no) && !this.valid.isEmpty(this.spotDriverData.vehicle_type)) {
      if (environment.country == 'IN' && !this.valid.isVehicle(this.spotDriverData.vehicle_no)) {
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.vehicle'), '', 'err');
        return false;
      } else if ((environment.country == 'SA' || environment.country == 'BR') && !this.valid.isKsaVehicle(this.spotDriverData.vehicle_no)) {
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.vehicle'), '', 'err');
        return false;
      } else if (!this.valid.isMobile(this.spotDriverData.mobile)) {
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.mobile'), '', 'err');
        return false;
      }
    } else {
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.allDetails'), '', 'err');
      return false;
    }
    return true;
  }

  selectVehicleType(event) {
    if (!event.checked) {
      this.vehicleType.id = this.selectedVehicleType.id;
      this.vehicleType.name = this.selectedVehicleType.name;
    } else {
      this.vehicleType.id = '';
      this.vehicleType.name = '';
    }
  }

  addSpotDriver() {
    this.spotDriverData.vehicle_type = this.vehicleType.id;

    const valid = this.validate(this.spotDriverData);
    let url = '';
    if (this.editDriver) {
      url = 'driver/edit_spot_on';
      this.spotDriverData.id = this.parentData.driverData.id;
    } else {
      url = 'driver/spot_on';
      delete this.spotDriverData.id;
    }
    if(!this.spotDriverData.gps_provider){
      delete this.spotDriverData.gps_provider;
    }
    if (valid) {
      this.showLoader = true;
      this.http.post(url, this.spotDriverData).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.showLoader = false;
            if (this.editDriver) {
              this.snackbar.openSnackBar(this.translate.instant('MESSAGE.DRIVERS.SPOT_ON.EDIT_SUCCESS'), '');
            } else {
              this.snackbar.openSnackBar(this.translate.instant('MESSAGE.DRIVERS.SPOT_ON.ADD_SUCCESS'), '');
            }
            this.dialog.close(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  // populate assets when provider is selected
  selectGPSProvider(provider) {
    console.log(provider)
    if (environment.country == 'SA') {
      this.spinner = true;
      this.showLoader = true;
      this.selectedGPSProvider = provider;
      this.spotDriverData.gps_provider = provider.value;
      this.selectedAsset = '';
      this.assets = [];
      this.assetsArray = [];
      this.http.get('ksa_gps/assets', {provider: provider.value},3).subscribe(
        (data: any) => {
          this.spinner = false;
          this.assetsArray = data.data;
          this.assets = data.data;
        },
        (err)=>{
          this.spinner = false;
          this.snackbar.openSnackBar(err.error.message,'','err');
        });
    } else {
      this.selectedGPSProvider = provider;
      this.spotDriverData.gps_provider = provider.value;
    }
  }

  selectAsset(asset) {
    this.selectedAsset = asset.reg_number;
    this.spotDriverData.gps_id = asset.asset_id;
  }

  applyFilter(value: string) {
    if (value) {
      this.assets = this.assets.filter(option => option.reg_number.includes(value));
    } else {
      this.spotDriverData.gps_id = '';
      this.assets = this.assetsArray;
    }
  }


  selectVehicle(vehicle) {
    // this.postShipmentData.vehicleType = vehicle._id;
    this.vehicleType.id = vehicle._id;
    this.vehicleType.name = vehicle.name;
  }

  closeDialog() {
    this.dialog.close();
  }

}
